import { call, put, takeLatest } from "redux-saga/effects";
import { CommonAPI } from "../../../api/commonAPI";
import {
  GET_RESERVATIONS_SUMMARY_REQUEST,
  GET_RESERVATIONS_SUMMARY_SUCCESS,
  GET_RESERVATIONS_SUMMARY_ERROR
} from "../../actions";

function* workerReservationsSummary(action: {
  type: string;
  payload: any;
  meta?: { period?: string };
}): Generator<any> {
  try {
    const response: any = yield call(
      CommonAPI.getReservationsSummary,
      action.payload
    );
    // Filter only all_time_income and unique_reservations_* keys
    let filtered: Record<string, any> = {};
    const fullData = response?.data || {};
    // Determine period key
    let period =
      action?.meta?.period ||
      (action.payload && action.payload.param) || "summary";
    yield put({
      type: GET_RESERVATIONS_SUMMARY_SUCCESS,
      payload: { [period]: fullData },
    });
  } catch (error) {
    yield put({ type: GET_RESERVATIONS_SUMMARY_ERROR, payload: error });
  }
}

export function* watcherReservationsSummary() {
  yield takeLatest(GET_RESERVATIONS_SUMMARY_REQUEST, workerReservationsSummary);
}
